var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-back"},[_c('div',{staticClass:"back-btn",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"icon-arrow-left"}),_vm._v(" Back ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }